import { useParams } from "react-router-dom"
import {
  CalendlyStatus,
  ConversationsWithListAndThread,
  If,
  NoConversationMsg,
  PageHeader
} from "../../common/ui"
import { Fragment } from "react"
import { useGetCalendarIntegrationQuery } from "../../redux/queries"
import { useConversations, useInMobileView } from "../../common/hooks"
import Ding from "../../assets/sounds/ding.mp3"
import { useSelector } from "react-redux"
import { currentThread } from "../../redux/slices/conversations"
import { formatPhoneNumber } from "../../common/utils"

const Conversations = () => {
  const {
    threads,
    isLoading: isLoadingQuery,
    playNewMessageSound,
    isLoadingQueryChange
  } = useConversations()

  const inMobileView = useInMobileView()

  const { _id = "" } = useParams<{ _id: string }>()

  const thread = useSelector(currentThread)

  const { data, isFetching } = useGetCalendarIntegrationQuery(
    { thread_id: _id },
    { skip: !_id }
  )

  let senderPhone =
    thread?.sender_phone && thread?.sender_phone?.startsWith("+1")
      ? formatPhoneNumber(thread.sender_phone.slice(2))
      : ""

  return (
    <Fragment>
      <div
        className={`p-6 pt-4 sm:pt-6 bg-white border-b border-neutral-200 ${
          _id ? "hidden md:block" : ""
        }`}
      >
        <PageHeader
          title="Conversations"
          hasSubtitle={inMobileView}
          subtitle={inMobileView && !!senderPhone ? `SMS#: ${senderPhone}` : ""}
        >
          <div className="flex items-center gap-4 md:gap-8">
            <If
              condition={!inMobileView && !!senderPhone}
              then={<span>SMS#: {senderPhone}</span>}
            />
            <If
              condition={!isFetching}
              then={<CalendlyStatus on={!Array.isArray(data)} />}
            />
          </div>
        </PageHeader>
      </div>

      <If
        condition={threads?.length === 0 && !isLoadingQuery}
        then={<NoConversationMsg />}
        else={
          <ConversationsWithListAndThread
            isLoading={isLoadingQueryChange}
            threads={threads}
          />
        }
      />

      {playNewMessageSound && <audio src={Ding} autoPlay />}
    </Fragment>
  )
}

export default Conversations
